export default __webpack_public_path__ + "static/media/mso_img.7b2a7138.png";